import type { CSSProperties } from 'react';
import type { RenderElementProps } from 'slate-react';

import { getStyle } from '../utils';

export const NumberedList = ({ attributes, element, children }: RenderElementProps) => {
  const style: CSSProperties = getStyle(element);

  if (element.listStyleType) {
    style.listStyleType = element.listStyleType;
  }

  return (
    <ol
      {...attributes}
      style={style}
    >
      {children}
    </ol>
  );
};
